<template>
  <div class="wrapper" v-if="isLogin">
    <div class="left">
      <title-a title="实时数据" font="18" />
      <div class="box">
        <!-- 统计 -->
        <div class="real-time-data">
          <sum title="在职人数" :num="onJobNumber" num_up>
            <img class="icon" src="@/assets/icons/Incumbency@2x.png" alt />
          </sum>
          <sum title="离职人数" :num="quitNumber" num_up>
            <img class="icon" src="@/assets/icons/Quitnumber@2x.png" alt />
          </sum>
          <sum title="社保参缴人数" :num="socialNumber" num_up>
            <img class="icon" src="@/assets/icons/insuredpersons@2x.png" alt />
          </sum>
          <sum title="公积金参缴人数" :num="gjjNumber" num_up>
            <img class="icon" src="@/assets/icons/Accumulation@2x.png" alt />
          </sum>
          <sum title="发薪人数" :num="salaryNumber" num_up>
            <img class="icon" src="@/assets/icons/Salarypayroll@2x.png" alt />
          </sum>
          <sum title="待签劳动合同人数" :num="waitContractNumber" num_up>
            <img class="icon" src="@/assets/icons/signed@2x.png" alt />
          </sum>
        </div>
      </div>
      <title-a more path="/EmploymentData" title="月度统计" font="18" paddingRight="23" />
      <div class="Row">
        <div class="left" style="margin-right: 32px">
          <div class="box">
            <title-a padding="48" title="用工概况" />
            <div class="title_border" />
            <div class="employee-overview h_padding48">
              <div class="item month" style="background-color: #6f5cf5;">
                <div class="month_title">
                  <p class="font_12_white">当前月份</p>
                  <img class="icon" src="@/assets/icons/calendar@2x.png" alt />
                </div>
                <p class="font_18_white">{{detailData2.periodLabel}}</p>
                <div class="calendar">
                  <span
                    v-for="item in monthList"
                    :key="item"
                    :class="{highlight: highlightMonth === item}"
                  >{{item}}</span>
                </div>
              </div>
              <div class="item">
                <div class="top">
                  <p class="font_14_gray data_title">月末在职人数</p>
                  <p class="font_24_black data">{{detailData2.periodEndOnJobCount || 0}}</p>
                </div>
                <div class="title_border" />
                <div class="bottom">
                  <img class="icon-emplpoy" src="@/assets/icons/Endofmonth@2x.png" alt />
                </div>
              </div>
              <div class="item">
                <div class="top">
                  <p class="font_14_gray data_title">新进人数</p>
                  <p class="font_24_black data">{{detailData2.periodNewHireCount || 0}}</p>
                  <p class="font_14_gray data_title">新进率</p>
                  <p class="font_24_black data">
                    {{percent(detailData2.periodNewRate)}}
                    <span
                      v-show="detailData2.periodNewRateMoM > 0"
                      class="rate_up font_12_green"
                    >
                      <img class="wave" src="@/assets/icons/up@2x.png" alt />
                      <span>{{percent(detailData2.periodNewRateMoM)}}</span>
                    </span>
                    <span v-show="detailData2.periodNewRateMoM < 0" class="rate_down font_12_red">
                      <img  class="wave"  src="@/assets/icons/down@2x.png" alt />
                      <span>{{percent(Math.abs(detailData2.periodNewRateMoM))}}</span>
                    </span>
                  </p>
                </div>
                <div class="title_border" />
                <div class="bottom">
                  <img class="icon-emplpoy" src="@/assets/icons/Newnumber@2x.png" alt />
                </div>
              </div>
              <div class="item">
                <div class="top">
                  <p class="font_14_gray data_title">离职人数</p>
                  <p class="font_24_black data">{{detailData2.periodExitCount || 0}}</p>
                  <p class="font_14_gray data_title">离职率</p>
                  <p class="font_24_black data">
                    {{percent(detailData2.periodLeaveRate)}}
                    <span
                      v-show="detailData2.periodLeaveRateMoM > 0"
                      class="rate_up font_12_green"
                    >
                      <img class="wave" src="@/assets/icons/up@2x.png" alt />
                      <span>{{percent(detailData2.periodLeaveRateMoM)}}</span>
                    </span>
                    <span v-show="detailData2.periodLeaveRateMoM < 0" class="rate_down font_12_red">
                      <img  class="wave"  src="@/assets/icons/down@2x.png" alt />
                      <span>{{percent(Math.abs(detailData2.periodLeaveRateMoM))}}</span>
                    </span>
                  </p>
                </div>
                <div class="title_border" />
                <div class="bottom">
                  <img  class="icon-emplpoy" src="@/assets/icons/Turnovernumber@2x.png" alt />
                </div>
              </div>
            </div>
            <div class="h_padding48" style="display: flex;">
              <!-- 折线图 -->
              <div id="line" class="line-charts"></div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="box">
            <title-a padding="48" title="薪酬概况" />
            <div class="title_border" />
            <div class="salary-overview h_padding48">
              <!-- 柱形图 -->
              <div id="bar" class="bar-charts"></div>
              <div class="bottom">
                <sum
                  class="item"
                  title="本月发薪总金额"
                  :amount="detailData1.periodTotalAmount"
                  :rate_up="detailData1.totalAmountQOQ_rate_up"
                  :rate_down="detailData1.totalAmountQOQ_rate_down"
                >
                  <img class="icon" src="@/assets/icons/company@2x.png" alt />
                </sum>
                <sum title="个税总金额" :amount="detailData1.periodTotalDeductionAmount">
                  <img class="icon" src="@/assets/icons/personalincometax@2x.png" alt />
                </sum>
                <sum
                  title="平均工资"
                  :amount="detailData1.periodAverageWage"
                  :rate_up="detailData1.averageWageQOQ_date_up"
                  :rate_down="detailData1.averageWageQOQ_date_down"
                >
                  <img class="icon" src="@/assets/icons/averagewage@2x.png" alt />
                </sum>
                <sum title="发放人数" :num="detailData1.periodPayTimes">
                  <img class="icon" src="@/assets/icons/Issuetimes@2x.png" alt />
                </sum>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="top section box">
        <title-a more padding="36" title="通知提醒" path="/Message" />
        <div padding="36" class="title_border" />
        <div class="message_box">
          <article-a
            v-for="(item, key) in messageList"
            :key="key"
            :type="item.messageTypeName"
            :title="item.title"
            :date="date(item.creationTime)"
            @click.native="viewMsg(item)"
            tagColor="#fdf0ea"
            tagFontColor="#f26828"
          />
          <div v-show="!messageList || messageList.length === 0" class="noData">
            <img class="nodata_img" src="@/assets/icons/nodata.png" alt="">
            <p class="font_16_gray">暂无通知提醒</p>
          </div>
        </div>
      </div>
      <div class="bottom section box">
        <title-a more padding="36" title="政策公告" path="/Policy" />
        <div class="title_border" />
        <div class="message_box">
          <article-a
            v-for="(item, key) in policyList"
            :key="key"
            :type="item.city"
            :title="item.noticeName"
            :date="date(item.announceTime)"
            @click.native="viewPolicy(item)"
            tagColor="#eff2fe"
            tagFontColor="#5c74f5"
          />
          <div v-show="!policyList || policyList.length === 0" class="noData">
            <img class="nodata_img" src="@/assets/icons/nodata.png" alt="">
            <p class="font_16_gray">暂无政策公告</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { dateConvert, Line, toPercent, initZone, getWatermarkOption } from "@/js/tool";
import { Get } from "@/js/http";

export default {
  components: {},
  props: {},
  data() {
    return {
      onJobNumber: 0, // 月末在职人数
      quitNumber: 0, // 离职人数
      socialNumber: 0, // 社保参缴人数
      gjjNumber: 0, // 公积金参缴人数
      salaryNumber: 0, // 发薪人数
      waitContractNumber: 0, // 待签劳动合同人数

      policyList: [], // 政策公告
      messageList: [], // 通知提醒
      
      sourceData1: [], // 柱状图源数据
      sourceData2: [], // 折线图源数据
      detailData1: {}, // 柱状图详细数据
      detailData2: {}, // 折线图详细数据
      customerShortName: '武汉行舟', // 企业简称（用于水印）
      barData: {
        xArray: ["2019-03", "2019-03", "2019-03", "2019-03", "2019-03"],
        legend: [],
        valueData: [546124, 54821, 16541, 25849, 57123]
      },
      // 折线图和柱状图的时间范围
      during: initZone('m', 6, 'd').map(item => {
        return dateConvert(item, { format: "Y-M-D" })
      }),
      during2: initZone('m', 6, 'd').map(item => {
        return dateConvert(item, { format: "Y-M" })
      })
    };
  },
  watch: {},
  computed: {
    // 日历月份列表
      monthList() {
        let currentMonth = this.detailData2.periodLabel ? new Date(this.detailData2.periodLabel).getMonth() + 1 : new Date().getMonth() + 1;
        let monthList = [];
        for (let item = 1; item <= 9; item++) {
          if (currentMonth > 3) {
            monthList.push(item + 3); // 显示4-12
          } else {
            monthList.push(item); // 显示1-9
          }
        }
        return monthList;
      },
    // 高亮的月份
    highlightMonth() {
      if (this.detailData2.periodLabel) {
        return new Date(this.detailData2.periodLabel).getMonth() + 1;
      } else {
        return 0;
      }
    },
    // 薪酬环比
    totalAmountQOQ() {
      return this.upOrDown(this.detailData1.totalAmountQOQ)
        ? this.detailData1.totalAmountQOQ
        : "";
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    viewPolicy(item) {
      this.$router.push({
        name: "Policy",
        params: {
          noticeID: item.noticeId
        }
      });
    },
    viewMsg(item) {
      this.$router.push({
        name: "MessageItem",
        params: {
          id: item.id
        }
      });
    },
    // 获取客户信息（用于水印）
    getCustomerInfo() {
      Get("api/v1.0/customers/info").then(res => {
        if (res.isSuccess && res.data) {
          this.customerShortName = res.data.customerShortName || '武汉行舟';
        }
      }).catch(() => {
        this.customerShortName = '武汉行舟';
      });
    },
    // 获取所有数据
    getData() {
      Get("api/v1/dashboard/summary").then(res => {
        let data = res.data;
        
        // 实时数据
        this.onJobNumber = data.employeeStatistics?.hiredCount || 0;
        this.quitNumber = data.employeeStatistics?.firedCount || 0;
        this.waitContractNumber = data.employeeStatistics?.toSignContractCount || 0;
        this.socialNumber = data.socialSecurityStatistics?.socialSecurityCount || 0;
        this.gjjNumber = data.socialSecurityStatistics?.providentFundCount || 0;
        
        // 政策公告
        this.policyList = data.policyNotices || [];
        
        // 通知提醒
        this.messageList = data.messages || [];
        
        // 用工概况数据
        this.sourceData2 = data.employeeReports || [];
        if (this.sourceData2.length > 0) {
          this.detailData2 = this.sourceData2[this.sourceData2.length - 1];
          
          // 绘制折线图
          this.lineData = {
            xData: this.sourceData2.map(item => item.periodLabel),
            legend: ["月末在职人数", "新进人数", "离职人数"],
            valueData: [
              this.sourceData2.map(item => item.periodEndOnJobCount),
              this.sourceData2.map(item => item.periodNewHireCount),
              this.sourceData2.map(item => item.periodExitCount)
            ]
          };
          this.line = this.drawLine("line", this.lineData);
        }
        
        // 薪酬概况数据
        this.sourceData1 = data.salaryReports || [];
        if (this.sourceData1.length > 0) {
          this.detailData1 = this.sourceData1[this.sourceData1.length - 1];
          this.salaryNumber = this.detailData1.periodPayTimes || 0;
          
          // 绘制柱状图
          let barData = [["amount", "month"]];
          this.sourceData1.map(value => {
            barData.push([value.periodTotalAmount, value.periodLabel]);
          });
          this.bar = this.drawBar("bar", barData);
        }
      });
    },
    // 绘制折线图
    drawLine(id, data) {
      const domElement = document.getElementById(id);
      if (!domElement) {
        console.error(`DOM元素 ${id} 不存在`);
        return null;
      }
      return Line.call(this, id, data, {
        title: "",
        watermarkText: this.customerShortName,
        option: {
          tooltip: {
            trigger: "axis",
            // 利用提示框formatter方法修改实例外变量
            formatter: p => {
              if (p instanceof Array) {
                this.detailData2 = this.sourceData2.find(
                  item => p[0].name === item.periodLabel
                );
              }
            }
          },
          grid: {
            left: "5%",
            right: "5%",
            bottom: "20%",
            containLabel: true
        },
        }
      });
    },
    // 绘制柱形图
    drawBar(id, data) {
      const domElement = document.getElementById(id);
      if (!domElement) {
        console.error(`DOM元素 ${id} 不存在`);
        return null;
      }
      let bar = echarts.init(domElement); // DOM元素初始化为echarts对象
      bar.setOption({
        dataset: {
          source: data
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none" // 取消鼠标悬停柱条标线
          },
          // 利用提示框formatter方法修改实例外变量
          formatter: p => {
            if (p instanceof Array) {
              // p[0].name是x轴标签名
              let data = this.sourceData1.find(
                item => p[0].name === item.periodLabel
              );
              data.totalAmountQOQ_rate_up =
                this.upOrDown(data.periodTotalAmountQoQ) > 0
                  ? data.periodTotalAmountQoQ.replace("-", "")
                  : "";
              data.totalAmountQOQ_rate_down =
                this.upOrDown(data.periodTotalAmountQoQ) < 0
                  ? data.periodTotalAmountQoQ.replace("-", "")
                  : "";
              data.averageWageQOQ_date_up =
                this.upOrDown(data.periodAverageWageQoQ) > 0
                  ? data.periodAverageWageQoQ.replace("-", "")
                  : "";
              data.averageWageQOQ_date_down =
                this.upOrDown(data.periodAverageWageQoQ) < 0
                  ? data.periodAverageWageQoQ.replace("-", "")
                  : "";
              this.detailData1 = data;
            }
          }
        },
        // 网格
        grid: {
          left: "2%",
          top: "10%",
          bottom: "0%",
          containLabel: true // grid区域包含刻度标签，防刻度标签文字溢出
        },
        // x轴
        xAxis: {
          position: "top", // x轴靠上
          axisLine: {
            lineStyle: {
              opacity: 0 // 不显示轴线
            }
          },
          axisTick: {
            show: false // 不显示刻度
          },
          axisLabel: {
            formatter: value => {
              if (value > 1000) {
                return value / 1000 + "K";
              } else {
                return value;
              }
            },
            rotate: -45,
            color: "#b8bac9" // 刻度标签样式
          }
        },
        // y轴
        yAxis: {
          type: "category",
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              opacity: 0 // 不显示轴线
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#b8bac9"
          }
        },
        series: [
          {
            name: "薪酬总金额",
            type: "bar", // 柱图
            barWidth: 10, // 柱条宽度
            itemStyle: {
              color: "#69d4fe", // 柱条颜色
              barBorderRadius: 50 // 柱条圆角
            },
            emphasis: {
              itemStyle: {
                color: "#05b8fe" // 鼠标悬停时柱条颜色
              }
            },
            barCategoryGap: "1%",
            barGap: "1%",
            encode: {
              x: "amount",
              y: "product"
            }
          }
        ],
        graphic: getWatermarkOption(this.customerShortName)
      });
      return bar;
    },

    // 转换方法
    percent(target) {
      if (target >= 10) {
        return toPercent(target, 1);
      } else {
        return toPercent(target, 2);
      }
    },
    date(date) {
      return dateConvert(date);
    },
    // 判断百分数字符串正负
    upOrDown(percent) {
      if (percent) {
        percent = percent.replace("%", "");
        percent = Number(percent);
        return percent;
      } else {
        return "";
      }
    },

    // 绑定窗口缩放事件
    ifResize() {
      window.addEventListener("resize", this.resize);
    },
    resize() {
      if (this.bar) {
        this.bar.resize();
      }
      if (this.line) {
        this.line.resize();
      }
    }
  },
  created() {},
  mounted() {
    this.getCustomerInfo();
    this.getData();
    this.ifResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  padding-bottom: 24px;
  > .left {
    width: 1231px;
    margin: 0 32px;
    > .Row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: stretch;
      .box {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
      > .left {
        width: 814px;
        height: 868px;
        // margin-right: 32px;
        .box {
          height: 100%;
        }
      }
      > .right {
        width: 385px;
        height: 868px;
      }
    }
  }
  > .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 58px;
    .section {
      display: flex;
      flex-direction: column;
      height: 494px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
.box {
  width: 100%;
  background-color: #ffffff;
  border-radius: 10px;
}
.real-time-data {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100px;
}
.employee-overview {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 40px;
  padding-bottom: 40px;
  line-height: 1;
  .item {
    display: flex;
    flex-direction: column;
    width: 145px;
    height: 266px;
    background-color: rgba(234, 234, 238, 0.5);
    border-radius: 10px;
    &.month {
      padding: 22px 18px 0 18px;
    }
    .month_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 6px;
    }
    .calendar {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 40px 0;
      flex-wrap: wrap;
      font-size: 12px;
      color: #fff;
      span {
        display: block;
        width: 29px;
        height: 29px;
        text-align: center;
        line-height: 29px;
      }
      .highlight {
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
      }
    }

    .top {
      flex: 1;
      padding-top: 22px;
      padding-left: 18px;
    }
    .bottom {
      padding-top: 22px;
      padding-left: 18px;
      height: 92px;
    }
    .data_title {
      padding-bottom: 13px;
    }
    p.data {
      white-space: nowrap;
      letter-spacing: -1px;
      > span {
        letter-spacing: 0px;
        position: relative;
        left: -8px;
      }
    }
    .data {
      padding-bottom: 26px;
      &:last-child {
        padding-bottom: 0;
      }
    }
    .rate_up {
      vertical-align: top;
      span {
        transform: scale(0.84, 0.84);
      }
    }
    .rate_down {
      vertical-align: top;
      span {
        transform: scale(0.84, 0.84);
      }
    }
  }
}

.salary-overview {
  display: flex;
  flex-direction: column;
  flex: 1;
  > .bottom {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 16% 0;
  }
}
.message_box {
  flex: 1;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  padding: 28px 28px 0 36px;
  div {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.line-charts {
  flex: 1;
  height: 400px;
}
.bar-charts {
  width: 100%;
  height: 370px;
}

.icon-emplpoy {
  width: 49px;
  height: 48px;
}
.wave {
  width: 13px;
  height: 8px;
}
</style>